export const useGTag = () => {
  if (!import.meta.client) return;

  const config = useRuntimeConfig();
  const consentCookie = useCookie<boolean>("cookie-consent");

  if (consentCookie.value === true) {
    window.dataLayer = window.dataLayer || [];

    function gtag(...rest: unknown[]) {
      window.dataLayer.push(arguments);
    }

    gtag("js", new Date());
    gtag("config", config.public.gtag);
  }
};
